import { useMatchesData } from './use-matches-data'

export function useAnalyticsEnabled() {
  const data = useMatchesData('routes/__shop')

  if (!data || typeof data.analyticsEnabled !== 'boolean') {
    return false
  }

  return data.analyticsEnabled
}
